module.exports = __webpack_public_path__ + "img/220.problem_right_elevator.8e73eb60.svg";